module.exports = __webpack_public_path__ + "static/media/long-arrow-up.61f3d81a.svg";